import React, { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import eyeOpenIcon from "../../Assests/Icons/eye_open.png";
import eyeCloseIcon from "../../Assests/Icons/eye_close.png";
import classes from "./CommonInput.module.css";
import { useLocation } from "react-router-dom";
interface props {
  name: string;
  value?: any;
  onChange?: (value: any) => void;
  required?: boolean;
  error?: any;
  touched?: any;
  labelname?: string;
  onPaste?: any;
  maxLength?: any;
  onKeyDown?: any;
  isInvalid?: any;
  onBlur?: any;
  readonly?: boolean;
  type?: "password" | "number" | "text";
  preIcon?: string;
  preIconStyles?: React.CSSProperties;
}

function CommonInput({
  value,
  required = false,
  name,
  onChange,
  error,
  labelname,
  touched,
  onPaste,
  maxLength,
  onKeyDown,
  isInvalid,
  onBlur,
  readonly = false,
  type,
  preIcon,
  preIconStyles,
}: props) {
  const [password, setPassword] = useState(false);
  const location = useLocation();
  const { pathname } = location;

  useEffect(() => {
    if (type === "password") {
      setPassword(true);
    }
  }, [type]);

  return (
    <>
      <div>
        <Form.Group>
          <Form.Label>{labelname}</Form.Label>
          {required && <span className="required_text">*</span>}
          <div
            className={`position-relative ${
              preIcon ? classes.inputPreContainer : ""
            } ${type === "password" ? classes.inputPostContainer : ""}`}
          >
            {preIcon ? (
              <img
                style={preIconStyles}
                className={classes.preIcon}
                src={preIcon}
                alt="preIcon"
              />
            ) : null}
            <Form.Control
              name={name}
              value={value}
              onChange={onChange}
              onPaste={onPaste}
              maxLength={maxLength}
              onKeyDown={onKeyDown}
              isInvalid={isInvalid}
              onBlur={onBlur}
              type={password ? "password" : "text"}
              readOnly={readonly}
              placeholder={labelname}
            />

            {type === "password" ? (
              <img
                onClick={() => {
                  setPassword((pre) => !pre);
                }}
                className={classes.postIcon}
                src={password ? eyeOpenIcon : eyeCloseIcon}
                alt="eyeCloseIcon"
              />
            ) : null}
          </div>
        </Form.Group>
        {required && touched?.[name] && error?.[name] && (
          <Form.Text
            className="required_text"
            style={{
              marginTop: "1px",
              position: pathname === "/" ? "absolute" : undefined,
            }}
          >
            {error?.[name]}
          </Form.Text>
        )}
      </div>
    </>
  );
}

export default CommonInput;
